import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import HCaptcha from '@hcaptcha/react-hcaptcha';

import {
  checkAuth,
  generateCookie,
  getOriginParam,
  getUserData,
  generateCookieHcaptcha,
} from '../../utils/data';
import env from '../../utils/env';
import Cookies from 'universal-cookie';
import ValidCookieForm from './ValidCookieForm';

import {
  setUserData,
  setUsername,
  setPassword,
} from '../../actions/userActions';
import { setViewMessages, showPrompt } from '../../actions/viewActions';
import { emailRegex, notEmptyRegex } from '../../utils/regex';
import {
  segmentEnum,
  track,
  identifyUser,
  trackPage,
  clickedElement,
} from '../../utils/segment';
import { gotoPageAfterXSecond } from '../../utils/commons';
import { Link } from 'react-router-dom';

import './Home.css';

const defaultMsg = (
  <span>
    The email or password you entered is incorrect.{' '}
    <Link to={{ pathname: `/lost-password` }}>Lost your password?</Link>
  </span>
);
const cookies = new Cookies();

const ESCAPE_KEY = 27;
var keypressCount = 0;

class Home extends Component {
  state = {
    loggingIn: false,
    passwordReset: cookies.get('pwr') === '1' ? true : false,
    isValidCookie: false,
    hcaptchaToken: '',
    hcaptchaOn: false,
  };

  _handleKeyDown = (event) => {
    switch (event.keyCode) {
      case ESCAPE_KEY:
        console.log('Escape key press : ' + this.props.testingHcaptcha);
        keypressCount++;
        if (keypressCount >= 2) {
          if (this.props.testingHcaptcha) {
            this.setState({ ...this.state, hcaptchaOn: true });
          }
          keypressCount = 0;
        }
        break;
      default:
        break;
    }
  };

  componentWillMount() {
    document.removeEventListener('keydown', this._handleKeyDown);
  }

  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyDown);
    this.props.setViewMessages([]);
    //Verify cookie and switch view accordingly
    checkAuth((res) => {
      var isValidCookie = true;
      if (!origin || !res.ok) {
        isValidCookie = false;
      }
      //Add overlay model for body
      if (isValidCookie) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
      this.setState({ ...this.state, isValidCookie: isValidCookie });
      trackPage(null, 'Login', { has_valid_cookie: isValidCookie });
    });
    //bind track event to the default forgot password work link
    //the event will be fired when user click the link
    clickedElement({
      target_element: document.getElementsByClassName('lost'),
      data: {
        element_name: 'forgot your password',
        password_reset: this.state.passwordReset,
      },
    });
  }

  handleUpdateUsername = (e) => {
    this.props.setUsername(e.target.value);
  };

  handleUpdatePassword = (e) => {
    this.props.setPassword(e.target.value);
  };

  isPasswordChangeRequired = (res) => {
    return res && res.message === 'Password change required';
  };

  isInvalidHcaptcha = (res) => {
    return res && res.message.includes('hcaptcha');
  };

  processSuccessLogin = (origin) => {
    //call user self end point for getting logged in user info
    let passwordReset = this.state.passwordReset;
    getUserData().then((userRes) => {
      try {
        if (userRes.status === 200) {
          userRes.json().then((userJson) => {
            var subStatus = '';
            try {
              if (userJson['subscriptions']['live']) {
                subStatus = userJson['subscriptions']['live'][0]['state'];
              } else if (userJson['subscriptions']['expired']) {
                subStatus = userJson['subscriptions']['expired'][0]['state'];
              }
            } catch (e) {
              //not found index can be happen
            }
            //Set user identify, all sub tracking would be associated with this user.
            identifyUser(userJson.user['wooId'], {
              roles: userJson['roles'],
              subscription_status: subStatus,
            });

            //Track logged in event
            track(segmentEnum.LoggedIn, {
              success: true,
              password_reset: passwordReset,
            });
          });
        } else {
          //Track logged in event
          //This case should not happen but
          //put the tracking here for just in case
          //user service being down right this time
          track(segmentEnum.LoggedIn, {
            success: true,
            password_reset: passwordReset,
          });
        }
      } catch (e) {
        //bypass any error for segment tracking
        console.log(e);
      }
      cookies.remove('pwr', { domain: env.originURL, path: '/' });
      //go to origin url after login successfully
      gotoPageAfterXSecond({
        goto_url: origin,
      });
    });
  };

  handleLogin = () => {
    // Validation
    const isEmail = emailRegex.test(this.props.username);
    const isPassword = notEmptyRegex.test(this.props.password);
    const inputValidation = [];
    const existsEmail = notEmptyRegex.test(this.props.username);
    const existsHcaptchaToken = notEmptyRegex.test(this.state.hcaptchaToken);
    this.props.setViewMessages([]);
    if (!isEmail) {
      if (!existsEmail) {
        inputValidation.push('Username is required.');
      } else {
        this.props.setViewMessages([defaultMsg]);
        clickedElement({
          target_element: document.getElementsByClassName('lost'),
          data: {
            element_name: 'forgot your password',
            password_reset: this.state.passwordReset,
          },
        });
        return;
      }
    }
    if (!isPassword) {
      if (existsEmail) {
        inputValidation.push('Please enter your password');
      } else {
        inputValidation.push('Password is required.');
      }
    }
    if (!isEmail || !isPassword) {
      this.props.setViewMessages(inputValidation);
      return;
    }

    //Added feature flag
    if (this.state.hcaptchaOn || this.props.showHcaptcha) {
      if (!existsHcaptchaToken) {
        inputValidation.push('Please verify that you are not a robot.');
        this.props.setViewMessages(inputValidation);
        return;
      } else {
        this.fetchCookie();
      }
    } else {
      //Not apply Hcaptcha feature flag
      this.fetchCookie();
    }
  };

  fetchCookie = () => {
    // Fetch cookie
    const { username, password } = this.props;
    this.setState({ ...this.state, loggingIn: true });
    if (this.state.hcaptchaOn || this.props.showHcaptcha) {
      generateCookieHcaptcha(username, password, this.state.hcaptchaToken).then(
        (res) => {
          if (res.status) {
            this.handleResponseGeneratedCookie(res);
          }
        }
      );
    } else {
      generateCookie(username, password).then((res) => {
        if (res.status) {
          // Only enable login button for failure case to allow re-login
          // When login sucessfull (200), we redirect to shop page (no need to set loggingIn=false)
          this.handleResponseGeneratedCookie(res);
        }
      });
    }
  };

  _handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin();
    }
  };

  handleVerificationSuccess = (token, ekey) => {
    this.setState({ ...this.state, hcaptchaToken: token });
  };

  handleResponseGeneratedCookie(res) {
    const origin = getOriginParam();
    switch (res.status) {
      case 401:
        res.json().then((json) => {
          let isPasswordChangeRequired = this.isPasswordChangeRequired(json);

          if (
            this.props.showPwdResetRequiredPrompt &&
            isPasswordChangeRequired
          ) {
            this.props.setViewMessages([]);
            clickedElement({
              target_element: document.getElementsByClassName('lost'),
              data: {
                element_name: 'forgot your password',
                password_reset: this.state.passwordReset,
              },
            });
            gotoPageAfterXSecond({
              goto_url: '/lost-password?isResetPasswordRequired=true',
            });
          } else {
            this.setState({ ...this.state, loggingIn: false });
            this.props.setViewMessages([defaultMsg]);
            this.props.showPrompt(undefined);
            clickedElement({
              target_element: document.getElementsByClassName('lost'),
              data: {
                element_name: 'forgot your password',
                password_reset: this.state.passwordReset,
              },
            });
          }

          //Track login fails
          track(segmentEnum.LoggedIn, {
            success: false,
            failed_reason: isPasswordChangeRequired
              ? 'password change required'
              : 'incorrect credentials',
            password_reset: this.state.passwordReset,
          });
        });
        break;

      case 400:
        res.json().then((result) => {
          if (this.isInvalidHcaptcha(result)) {
            this.setState({ ...this.state, loggingIn: false });
            this.props.setViewMessages(['Login failed. Please try again.']);
          } else {
            //Track login fails
            this.setState({ ...this.state, loggingIn: false });
            track(segmentEnum.LoggedIn, {
              success: false,
              failed_reason: 'bad request parameter',
              password_reset: this.state.passwordReset,
            });

            checkAuth((res) => {
              if (!origin || !res.ok) {
                // Message if origin param is missing
                this.props.setViewMessages([
                  <span>
                    Sorry, there was an error logging you in. Please{' '}
                    <Link to={{ pathname: `/lost-password` }}>click here </Link>{' '}
                    to reset your password or reach out to{' '}
                    <a href="https://fabfitfun.com/concierge/">
                      Customer Care.
                    </a>
                  </span>,
                ]);
                //need to rebind after adding message object
                clickedElement({
                  target_element: document.getElementsByClassName('lost'),
                  data: {
                    element_name: 'forgot your password',
                    password_reset: this.state.passwordReset,
                  },
                });
              } else {
                window.location = env.envURL;
              }
            });
          }
        });
        break;

      case 200:
        this.processSuccessLogin(origin);
        break;

      default:
        this.setState({ ...this.state, loggingIn: false });
        this.props.setViewMessages([defaultMsg]);
        track(segmentEnum.LoggedIn, {
          success: false,
          failed_reason: 'internal error',
          password_reset: this.state.passwordReset,
        });

        clickedElement({
          target_element: document.getElementsByClassName('lost'),
          data: {
            element_name: 'forgot your password',
            password_reset: this.state.passwordReset,
          },
        });
    }
  }

  render() {
    const {
      _handleKeyPress,
      handleUpdateUsername,
      handleUpdatePassword,
      handleLogin,
      handleVerificationSuccess,
    } = this;

    return (
      <React.Fragment>
        {this.state.isValidCookie ? (
          <ValidCookieForm />
        ) : (
          <div className="login-page mar-a" onKeyPress={_handleKeyPress}>
            <div className="login">
              <h2 className="login-page-h2">Member login</h2>
              <form>
                {this.props.promptMessage ? (
                  <div>{this.props.promptMessage}</div>
                ) : (
                  ''
                )}
                <div className="labelpair">
                  <label htmlFor="username">
                    Email Address
                    <span>*</span>
                  </label>
                  <input name="username" onChange={handleUpdateUsername} />
                </div>
                <div className="labelpair">
                  <label htmlFor="password">
                    Password
                    <span>*</span>
                  </label>
                  <input
                    name="password"
                    type="password"
                    onChange={handleUpdatePassword}
                  />
                </div>
                <div className="messages">
                  {this.props.messages.map((msg, index) => (
                    <div className="message" key={'message-' + index}>
                      <b>ERROR:</b> {msg}
                    </div>
                  ))}
                </div>
                {this.state.loggingIn ? (
                  <button className="login-page-button" type="button" disabled>
                    Logging In &nbsp;
                    <i className="far fa-spinner fa-spin" />
                  </button>
                ) : (
                  <button
                    className="login-page-button"
                    onClick={handleLogin}
                    type="button"
                  >
                    Login
                  </button>
                )}
              </form>
              <div className="links">
                <Link to={{ pathname: `/lost-password` }}>
                  Forgot your password?
                </Link>
              </div>
              {(this.state.hcaptchaOn || this.props.showHcaptcha) && (
                <div className="hcaptcha">
                  <HCaptcha
                    sitekey={`${env.hcaptchaSitekey}`}
                    onVerify={(token, ekey) =>
                      handleVerificationSuccess(token, ekey)
                    }
                  />
                </div>
              )}
              <h4 className="bottom">
                Not a member yet?{' '}
                <a href={`${env.envURL}/get-the-box/#getstarted`}>
                  Sign up now
                </a>
              </h4>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mS = (state) => ({
  username: state.user.username,
  password: state.user.password,
  user: state.user,
  isMobile: state.view.isMobile,
  messages: state.view.messages,
  promptMessage: state.view.promptMessage,
  showPwdResetRequiredPrompt: state.launchDarkly.showPwdResetRequiredPrompt,
  showHcaptcha: state.launchDarkly.showHcaptcha,
  testingHcaptcha: state.launchDarkly.testingHcaptcha,
});

const mD = (dispatch) =>
  bindActionCreators(
    {
      setUserData,
      setUsername,
      setPassword,
      setViewMessages,
      showPrompt,
    },
    dispatch
  );

export default connect(mS, mD)(Home);
